import { Component, OnInit, ViewChild } from '@angular/core';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';

import { LoaderComponent } from 'src/app/modules/shared/components/loader/loader.component';


@Component({
  selector: 'app-csv-file',
  templateUrl: './csv-file.component.html',
  styleUrls: [
    '../view-and-export-data.component.css',
    './csv-file.component.css',
  ],
})
export class CsvFileComponent implements OnInit {
  layerFeatures: any;
  features: any = [];
  arr: any = [];
  showMsg = false;
  url: any;
  allKeys: any = [];
  allLayersType: any = [];
  allLayersTypeName: any = [];
  boundaries: any;
  selectedLayers: any = [];
  @ViewChild(LoaderComponent) loader!: LoaderComponent;
  constructor(
    private mapService: MapServiceService,
    private sideNavService: SideNavService
  ) {
    //
  }

  ngOnInit(): void {
    this.layerFeatures = this.sideNavService.layersFeatures;
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;
    //getting id of layers
    for (let i = 0; i < this.layerFeatures.length; i++) {
      if (!this.allLayersType.includes(this.layerFeatures[i].layer_id)) {
        this.allLayersType.push(this.layerFeatures[i].layer_id);
      }
    }
    for (let i = 0; i < this.boundaries.length; i++) {
      for (let j = 0; j < this.allLayersType.length; j++) {
        if (
          this.boundaries[i].id.toString() ==
            this.allLayersType[j].toString() &&
          !this.allLayersTypeName.includes(this.boundaries[i].name)
        ) {
          this.allLayersTypeName.push(this.boundaries[i].name);
        }
      }
    }
  }

  download(): void {
    //for multiLayer
    if (this.selectedLayers.length > 0 && this.allLayersTypeName.length > 1) {
      this.showMsg = false;
      for (let i = 0; i < this.selectedLayers.length; i++) {
        for (let j = 0; j < this.boundaries.length; j++) {
          let layerName: any;
          let layerId: any;
          this.arr = [];
          this.allKeys = [];
          this.features = [];
          for (let k = 0; k < this.layerFeatures.length; k++) {
            if (
              this.boundaries[j].id.toString() ==
                this.layerFeatures[k].layer_id &&
              this.selectedLayers[i] == this.boundaries[j].name
            ) {
              this.features = [];
              layerName = this.boundaries[j].name;
              layerId = this.boundaries[j].id.toString();
              let keys: any = [];
              keys = Object.keys(this.layerFeatures[k].data);
              for (const key of Object.keys(this.layerFeatures[k].data)) {
                this.allKeys.push(this.layerFeatures[k].fields[key]);
              }
              //creating headers for file
              this.features.push(this.allKeys);

              for (let i = 0; i < this.layerFeatures.length; i++) {
                this.arr = [];
                for (let j = 0; j < keys.length; j++) {
                  if (this.layerFeatures[i].layer_id == layerId) {
                    this.arr.push(this.layerFeatures[i].data[keys[j]]);
                  }
                }
                if (this.arr.length != 0) {
                  this.features.push(this.arr);
                }
              }
              this.loader.toggleSpinner(true);
              const body = {
                download_type: 'csv_file',
                show_apn: false,
                use_mail_address: false,
                use_situs_address: false,
                skip_duplicates: false,
                table_name: 't',
                layer_name: layerName,
                map_name: this.mapService.mapData.map_data.map_data.name,
                features: this.features,
              };

              this.mapService.dataView(body).subscribe((res) => {
                if (res) {
                  this.url = `${this.sideNavService.downloadFileUrl}/media/csv_reports/${res.file_path}`;
                  this.features = [];
                  this.loader.toggleSpinner(false);
                  window.open(this.url, '_blank');
                }
              });
              break;
            }
          }
        }
      }
    } else if (
      this.selectedLayers.length === 0 &&
      this.allLayersTypeName.length > 1
    ) {
      this.showMsg = true;
    } else if (
      !this.layerFeatures.length ||
      (this.layerFeatures.length && this.allLayersType.length < 2)
    ) {
      let keys: any = [];
      this.allKeys = [];
      if (this.layerFeatures?.length) {
        keys = Object.keys(this.layerFeatures[0].data);

        for (const key of Object.keys(this.layerFeatures[0].data)) {
          this.allKeys.push(this.layerFeatures[0].fields[key]);
        }
      } else {
        keys = Object.keys(this.layerFeatures.data);

        for (const key of Object.keys(this.layerFeatures.data)) {
          this.allKeys.push(this.layerFeatures.fields[key]);
        }
      }

      //creating headers for file
      this.features.push(this.allKeys);
      if (this.layerFeatures?.length) {
        for (let i = 0; i < this.layerFeatures.length; i++) {
          this.arr = [];
          for (let j = 0; j < keys.length; j++) {
            this.arr.push(this.layerFeatures[i].data[keys[j]]);
          }
          if (this.arr.length != 0) {
            this.features.push(this.arr);
          }
        }
      } else {
        this.arr = [];
        for (let j = 0; j < keys.length; j++) {
          this.arr.push(this.layerFeatures.data[keys[j]]);
        }
        if (this.arr.length != 0) {
          this.features.push(this.arr);
        }
      }
      this.loader.toggleSpinner(true);
      const body = {
        download_type: 'csv_file',
        show_apn: false,
        use_mail_address: false,
        use_situs_address: false,
        skip_duplicates: false,
        table_name: 't',
        layer_name: 'Parcels',
        map_name: this.mapService.mapData.map_data.map_data.name,
        features: this.features,
      };
      this.mapService.dataView(body).subscribe((res:any) => {
        if (res) {
          this.url = `${this.sideNavService.downloadFileUrl}/media/csv_reports/${res.file_path}`;
          this.loader.toggleSpinner(false);
          window.open(this.url);
          this.features = [];
        }
      });
    }
  }

  onChange(e: any) {
    if (e.target.checked) {
      if (!this.selectedLayers.includes(e.target.value)) {
        this.selectedLayers.push(e.target.value);
      }
    } else {
      const index = this.selectedLayers.indexOf(e.target.value);
      if (index != -1) {
        this.selectedLayers.splice(index, 1);
      }
    }
  }
}
